import React, { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';

// Orden canónico de los días de la semana en español
const ORDEN_DIAS = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

const GraficaDias = ({ datos }) => {
    const dataGrafica = useMemo(() => {
        const conteo = {};
        datos.forEach((d) => {
            const dia = (d.DIA ?? '').toLowerCase().trim();
            if (dia) conteo[dia] = (conteo[dia] ?? 0) + 1;
        });

        // Ordenar por día de semana; si no está en ORDEN_DIAS va al final
        return Object.entries(conteo)
            .sort(([a], [b]) => {
                const ia = ORDEN_DIAS.indexOf(a);
                const ib = ORDEN_DIAS.indexOf(b);
                return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
            })
            .map(([dia, excesos]) => ({
                dia: dia.charAt(0).toUpperCase() + dia.slice(1),
                excesos,
            }));
    }, [datos]);

    return (
        <section className="ev-seccion">
            <h3 className="ev-seccion-titulo">
                <i className="pi pi-chart-bar" /> EXCESOS POR DÍA
            </h3>
            <div className="ev-grafica-contenedor">
                <ResponsiveBar
                    data={dataGrafica}
                    keys={['excesos']}
                    indexBy="dia"
                    margin={{ top: 20, right: 20, bottom: 50, left: 55 }}
                    padding={0.35}
                    colors={['#ef4444']}
                    borderRadius={3}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: -20,
                        legend: 'Día',
                        legendPosition: 'middle',
                        legendOffset: 42,
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        legend: 'Excesos',
                        legendPosition: 'middle',
                        legendOffset: -45,
                        format: (v) => Number.isInteger(v) ? v : '',
                    }}
                    labelSkipHeight={14}
                    label={(d) => d.value}
                    tooltip={({ value, indexValue }) => (
                        <div className="ev-tooltip">
                            <strong>{indexValue}</strong>: {value} exceso{value !== 1 ? 's' : ''}
                        </div>
                    )}
                    theme={{
                        axis: { ticks: { text: { fontSize: 12 } } },
                        labels: { text: { fontSize: 12, fontWeight: 700, fill: '#fff' } },
                    }}
                />
            </div>
        </section>
    );
};

export default GraficaDias;
